<template>
  <div>
    <!-- 日行程明细 -->
    <div>
      <div v-for="traver_item,index of day_trip_traver_list"
           class="traver_item"
           :key="index">
        <!-- 隐藏 加迹点 加交通 hover 显示-->
        <div class="add_traver_or_traffic_for_day_trip">
          <!-- <i style="margin-right:10px;cursor:pointer"
                   class="el-icon-circle-plus-outline">添加日行程</i> -->
          <i style="margin-right:10px;cursor:pointer; font-weight: 900;"
             @click="addTraverPoint(index)"
             class="el-icon-circle-plus-outline">添加迹点</i>
          <i style="margin-right:10px;cursor:pointer; font-weight: 900;"
             @click="addResidence(index)"
             class="el-icon-circle-plus-outline">添加酒店</i>
        </div>

        <!-- 迹点信息 -->
        <div v-if="'traver_title' in traver_item">
          <div class="editor_day_trip_style">
            <div style="padding:5px 10px"> {{traver_item.traver_title}}
              <span style="float:right;color:lightgray">
                <span>ID: {{traver_item.id}}</span>
                <!-- 编辑 -->
                <span style="margin-left:10px;cursor:pointer;color:#ff5421">
                  <i class="el-icon-edit-outline"
                     @click="editTraverPoint(index)"></i>
                </span>
                <!-- 移除 -->
                <span style="margin-left:10px;cursor:pointer;color:#ff5421">
                  <i class="el-icon-delete"
                     @click="delectTraverPoint(index)"></i>
                </span>
              </span>
            </div>

            <el-image :src="traver_item.traver_cover"></el-image>
            <!-- 简介 -->
            <div style="padding:5px 10px">
              简介： <span v-html="traver_item.traver_info"></span>
            </div>
            <!-- 营业时间 -->
            <!-- 注意事项 -->
            <div style="padding:5px 10px">
              📌Tips： <span v-html="traver_item.traver_remark"></span>
            </div>
            <!-- ---------------- -->
            <div style="padding:5px 10px; ">
              <!-- 内容 -->

              <div style="margin-bottom:10px"
                   v-if="traver_item.content_media.length != 0 ">
                <el-divider></el-divider>
                【内容】
                <div v-for="item,index in traver_item.content_media "
                     :key="index">🟧{{item.content_title}}</div>
              </div>

              <!-- 推荐 -->

              <div style="margin-bottom:10px"
                   v-if="traver_item.recommends.length != 0 ">
                <el-divider></el-divider>
                【周边推荐】
                <div v-for="item,index in traver_item.recommends"
                     :key="index">
                  🟩{{item.recommend_name}}
                </div>
              </div>
              <!-- 指南 -->

              <div style="margin-bottom:10px"
                   v-if="traver_item.guide_group.length != 0 ">
                <el-divider></el-divider>
                【游玩指南】
                <div v-for="item,index in traver_item.guide_group "
                     :key="index">🟦{{item.guide_title}}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 酒店信息 -->
        <div v-else>
          <div class="editor_day_trip_style">
            <!-- 酒店标题 -->
            <div style="padding:5px 10px"> 🏨 {{traver_item.residence_name}}
              <span style="float:right;color:lightgray">
                <span> ID: {{traver_item.id}}</span>
                <!-- 移除 -->
                <span style="margin-left:10px;cursor:pointer;color:#ff5421">
                  <i class="el-icon-delete"
                     @click="delectTraverPoint(index)"></i>
                </span>
              </span>

            </div>
            <!-- 图片 -->
            <div>
              <el-image :src="traver_item.residence_cover"></el-image>
            </div>
            <!-- 酒店简介 -->
            <div style="padding:5px 10px">
              简介：<span v-html="traver_item.residence_introduce"></span>
            </div>
          </div>
        </div>
        <!-- 交通信息：无 -->
        <div v-if="traver_item.TrafficPlan.length == 0">
          <div v-if="day_trip_traver_list.indexOf(traver_item)+1 !== day_trip_traver_list.length">
            <p class="traffic_title_style">
              🚘 未添加交通{{traver_item.TrafficPlan}}
              <span style="float:right;color: #ff5421;cursor:pointer">
                <i @click="selectOrAddTraffic(traver_item,index)"
                   class="el-icon-position"></i>
              </span>
            </p>
            <div style="text-align:center"> <i class="el-icon-arrow-down"></i> </div>
          </div>
        </div>
        <!-- 交通信息：有 -->
        <div v-else>
          <p class="traffic_title_style">
            🚘 交通方案：
            <span style="float:right;color: #ff5421;cursor:pointer">
              <i @click="selectOrAddTraffic(traver_item,index)"
                 class="el-icon-position"></i>
            </span>
          </p>
          <div v-for="plan,index in traver_item.TrafficPlan"
               :key="index">
            <div class="traffic_introduce_style">
              <div v-if="index!==0">------------------------------</div>
              <div>【方案{{index+1}}：{{plan.traffic_plan_name}}】</div>
              <div v-html="plan.traffic_introduce"></div>
            </div>
          </div>
          <!-- 下一站图标 -->
          <div style="text-align:center"> <i class="el-icon-arrow-down"></i> </div>
        </div>
        <!-- end -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'travel-plan-day-trip-style',
  data() {
    return {
      day_trip_traver_list: this.dayTripTraverList,
      day_index: this.index,
    }
  },
  props: {
    dayTripTraverList: Array,
    tripType: String,
    index: null,
  },
  watch: {
    // dayTripTraverList(newVal) {
    //   // console.log('日行程数据变化')
    //   this.day_trip_traver_list = newVal
    // },
    dayTripTraverList: {
      handler(newValue) {
        // console.log('日行程变化', newValue)
        this.day_trip_traver_list = newValue
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    addTraverPoint(index) {
      this.$emit('addTraverPoint', this.tripType, index)
    },
    addResidence(index) {
      this.$emit('addResidence', this.tripType, index)
    },
    editTraverPoint(item_index) {
      console.log('tripStyle:', item_index)
      this.$emit(
        'editTraverPointFromDayTrip',
        this.tripType,
        this.index,
        item_index
      )
    },
    delectTraverPoint(item_index) {
      // console.log('tripStyle:', item_index)
      this.$emit(
        'deleteTraverPointFromDayTrip',
        this.tripType,
        this.index,
        item_index
      )
    },
    // 打开两点间 交通编辑页
    selectOrAddTraffic(item, traver_index) {
      let next_item =
        this.day_trip_traver_list[this.day_trip_traver_list.indexOf(item) + 1]

      // console.log(
      //   '当前点',
      //   item,
      //   '迹点位置',
      //   traver_index,
      //   '日行程类型',
      //   this.tripType,
      //   '后一天',
      //   next_item
      // )
      console.log('迹点位置', traver_index)

      // 显示右侧的添加交通页面
      if (next_item) {
        this.$emit(
          'openTrafficEditor',
          this.tripType,
          traver_index,
          item,
          next_item
        )
      } else {
        this.$message({
          message: '请再添加一个迹点',
          type: 'error',
        })
      }

      // this.$emit()
    },
  },
}
</script>

<style >
.traver_item:hover .add_traver_or_traffic_for_day_trip {
  display: block;
}
.editor_day_trip_style {
  border: 1px solid lightgray;
  /* margin-top: 10px; */
}

.add_traver_or_traffic_for_day_trip {
  display: None;
  border: 1px solid rgb(236, 82, 10);
  background-color: #ff5421;
  color: #fff;
  padding: 5px;
  text-align: center;
}
.traffic_title_style {
  background-color: lightgray;
  padding: 5px;
}
.traffic_introduce_style {
  padding: 5px;
  background-color: rgb(241, 241, 241);
}
</style>